<template>
  <div>
    <el-row class="wenzi">开票信息</el-row>
    
    <!-- 信息展示区域 -->
    <el-row class="info-card">
      <div class="info-header">
        <span class="modify-link" @click="openDialog">修改</span>
      </div>
      <div class="info-content">
        <div class="info-item">
          <span class="info-label">抬头:</span>
          <span class="info-value">{{ form.invoiceTitle || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">统一社会信用代码:</span>
          <span class="info-value">{{ form.invoiceCertNo || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">地址:</span>
          <span class="info-value">{{ form.invoiceAddress || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">电话:</span>
          <span class="info-value">{{ form.invoiceTel || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">开户行:</span>
          <span class="info-value">{{ form.invoiceBank || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">账号:</span>
          <span class="info-value">{{ form.invoiceBankNo || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">邮箱:</span>
          <span class="info-value">{{ form.invoiceEmail || '-' }}</span>
        </div>
      </div>
    </el-row>

    <!-- 修改弹窗 -->
    <el-dialog title="开票信息修改" :visible.sync="dialogVisible" width="600px">
      <el-form
        ref="formName"
        :model="editForm"
        label-width="120px"
        class="form-aut"
      >
        <el-form-item prop="invoiceTitle" label="抬头:">
          <el-input
            v-model="editForm.invoiceTitle"
            placeholder="发票抬头,必须为著作权人之一"
          ></el-input>
        </el-form-item>
        <el-form-item prop="invoiceCertNo" label="统一社会信用代码:">
          <el-input
            v-model="editForm.invoiceCertNo"
            placeholder="统一社会信用代码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="invoiceAddress" label="地址:">
          <el-input
            v-model="editForm.invoiceAddress"
            placeholder="注册地址"
          ></el-input>
        </el-form-item>
        <el-form-item prop="invoiceTel" label="电话:">
          <el-input
            v-model="editForm.invoiceTel"
            placeholder="开户电话"
          ></el-input>
        </el-form-item>
        <el-form-item prop="invoiceBank" label="开户行:">
          <el-input
            v-model="editForm.invoiceBank"
            placeholder="开户银行"
          ></el-input>
        </el-form-item>
        <el-form-item prop="invoiceBankNo" label="账号:">
          <el-input
            v-model="editForm.invoiceBankNo"
            placeholder="银行账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="invoiceEmail" label="邮箱:">
          <el-input
            v-model="editForm.invoiceEmail"
            placeholder="邮箱"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmitUpdate">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { userUpdate } from '@/api/user.js'

export default {
  name: 'Invoiceinformation',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {
      dialogVisible: false,
      editForm: {
        invoiceTitle: '',
        invoiceCertNo: '',
        invoiceAddress: '',
        invoiceTel: '',
        invoiceBank: '',
        invoiceBankNo: '',
        invoiceEmail: ''
      }
    }
  },
  computed: {
    form () {
      return this.$store.state.realInformation
    }
  },
  watch: {},
  mounted () {},
  methods: {
    openDialog () {
      // 复制当前数据到编辑表单
      this.editForm = {
        invoiceTitle: this.form.invoiceTitle || '',
        invoiceCertNo: this.form.invoiceCertNo || '',
        invoiceAddress: this.form.invoiceAddress || '',
        invoiceTel: this.form.invoiceTel || '',
        invoiceBank: this.form.invoiceBank || '',
        invoiceBankNo: this.form.invoiceBankNo || '',
        invoiceEmail: this.form.invoiceEmail || ''
      }
      this.dialogVisible = true
    },
    onSubmitUpdate () {
      this.$refs.formName.validate((valid) => {
        if (valid) {
          const submitData = {
            ...this.editForm,
            userId: this.$store.state.userInfo.user.userId
          }
          userUpdate(submitData).then((res) => {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            // 更新 store 中的数据
            Object.assign(this.form, this.editForm)
            this.dialogVisible = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.wenzi {
  height: 60px;
  margin: 0 30px;
  line-height: 60px;
  color: #303133;
  font-weight: 600;
  font-size: 18px;
  border-bottom: 1px solid #ebeef5;
}

.info-card {
  margin: 24px 30px;
  padding: 24px 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
  max-width: 600px;
}

.info-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.modify-link {
  display: inline-flex;
  align-items: center;
  color: #409EFF;
  cursor: pointer;
  font-size: 14px;
  padding: 6px 16px;
  border-radius: 4px;
  transition: all 0.3s;
  
  &:hover {
    background-color: #ecf5ff;
  }
  
  &::before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23409EFF'%3E%3Cpath d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'/%3E%3C/svg%3E") no-repeat center;
    background-size: contain;
  }
}

.info-content {
  .info-item {
    display: flex;
    align-items: flex-start;
    padding: 12px 0;
    font-size: 14px;
    
    &:not(:last-child) {
      border-bottom: 1px dashed #f0f0f0;
    }
  }
  
  .info-label {
    flex-shrink: 0;
    width: 130px;
    color: #909399;
    font-weight: 500;
  }
  
  .info-value {
    flex: 1;
    color: #303133;
    word-break: break-all;
  }
}

.form-aut {
  padding: 10px 20px;
  
  ::v-deep .el-form-item {
    margin-bottom: 22px;
  }
  
  ::v-deep .el-form-item__label {
    color: #606266;
    font-weight: 500;
  }
  
  ::v-deep .el-input__inner {
    border-radius: 6px;
    
    &:focus {
      border-color: #409EFF;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
    }
  }
}

::v-deep .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  
  .el-dialog__header {
    padding: 20px 24px;
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    
    .el-dialog__title {
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }
    
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
  
  .el-dialog__body {
    padding: 24px;
  }
  
  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid #f0f0f0;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  
  .el-button {
    min-width: 100px;
    border-radius: 6px;
  }
}
</style>
